import React from 'react';

// Six named agent personas as one avatar component — ported 1:1 from the
// original Scout.dc.html (Claude Design) source. `head` crops to just the
// face for the small inline badges used throughout the demo.
export default function Scout({ agent, head = false, style, className }) {
  const KEYS = ['sari', 'cek', 'rani', 'wira', 'tara', 'scout'];
  const a = KEYS.includes(agent) ? agent : 'scout';
  const vb = head ? '8 0 104 92' : '0 0 120 124';

  return (
    <svg viewBox={vb} style={{ width: '100%', height: '100%', display: 'block', overflow: 'visible', ...style }} className={className}>
      {a === 'scout' && (
        <>
          <line x1="12" y1="104" x2="30" y2="98" stroke="#D5D7DE" strokeWidth="4" strokeLinecap="round" />
          <circle cx="10" cy="105" r="4.5" fill="#F4F4F2" />
          <line x1="108" y1="104" x2="90" y2="98" stroke="#D5D7DE" strokeWidth="4" strokeLinecap="round" />
          <circle cx="110" cy="105" r="4.5" fill="#F4F4F2" />
          <rect x="30" y="90" width="60" height="22" rx="11" fill="#16223F" stroke="#6F97FF" strokeWidth="2" />
          <text x="60" y="105" textAnchor="middle" fontFamily="Geist Mono, monospace" fontSize="10" fill="#B5CBFF">grocera</text>
          <line x1="60" y1="10" x2="60" y2="26" stroke="#C9CCD6" strokeWidth="3" />
          <circle cx="60" cy="9" r="6.5" fill="#2F6BFF" />
          <rect x="18" y="24" width="84" height="64" rx="22" fill="#F7F7F5" stroke="#E2E3E8" strokeWidth="1.5" />
          <circle cx="45" cy="53" r="6.5" fill="#141414" />
          <circle cx="47.2" cy="50.8" r="2" fill="#fff" />
          <circle cx="75" cy="53" r="6.5" fill="#141414" />
          <circle cx="77.2" cy="50.8" r="2" fill="#fff" />
          <ellipse cx="34" cy="66" rx="6.5" ry="3.8" fill="#F7B6C2" />
          <ellipse cx="86" cy="66" rx="6.5" ry="3.8" fill="#F7B6C2" />
          <path d="M50 66 Q60 76 70 66" stroke="#141414" strokeWidth="3.5" fill="none" strokeLinecap="round" />
        </>
      )}
      {a === 'sari' && (
        <>
          <line x1="12" y1="104" x2="30" y2="98" stroke="#D5D7DE" strokeWidth="4" strokeLinecap="round" />
          <circle cx="10" cy="105" r="4.5" fill="#F4F4F2" />
          <line x1="108" y1="96" x2="90" y2="98" stroke="#D5D7DE" strokeWidth="4" strokeLinecap="round" />
          <circle cx="110" cy="95" r="4.5" fill="#F4F4F2" />
          <rect x="30" y="90" width="60" height="22" rx="11" fill="#16223F" stroke="#6F97FF" strokeWidth="2" />
          <text x="60" y="105" textAnchor="middle" fontFamily="Geist Mono, monospace" fontSize="10" fill="#B5CBFF">sales</text>
          <line x1="60" y1="10" x2="60" y2="26" stroke="#C9CCD6" strokeWidth="3" />
          <circle cx="60" cy="9" r="6.5" fill="#2F6BFF" />
          <rect x="18" y="24" width="84" height="64" rx="22" fill="#F7F7F5" stroke="#E2E3E8" strokeWidth="1.5" />
          <circle cx="45" cy="53" r="6.5" fill="#141414" />
          <circle cx="47.2" cy="50.8" r="2" fill="#fff" />
          <circle cx="75" cy="53" r="6.5" fill="#141414" />
          <circle cx="77.2" cy="50.8" r="2" fill="#fff" />
          <ellipse cx="34" cy="66" rx="6.5" ry="3.8" fill="#F7B6C2" />
          <ellipse cx="86" cy="66" rx="6.5" ry="3.8" fill="#F7B6C2" />
          <path d="M50 66 Q60 76 70 66" stroke="#141414" strokeWidth="3.5" fill="none" strokeLinecap="round" />
          <path d="M16 50 Q16 16 60 16 Q104 16 104 50" stroke="#2F6BFF" strokeWidth="5" fill="none" />
          <rect x="8" y="42" width="13" height="22" rx="5.5" fill="#2F6BFF" />
          <rect x="99" y="42" width="13" height="22" rx="5.5" fill="#2F6BFF" />
          <path d="M106 62 Q106 81 84 80" stroke="#2F6BFF" strokeWidth="3" fill="none" strokeLinecap="round" />
          <circle cx="81" cy="80" r="4" fill="#2F6BFF" />
        </>
      )}
      {a === 'cek' && (
        <>
          <line x1="12" y1="104" x2="30" y2="98" stroke="#D5D7DE" strokeWidth="4" strokeLinecap="round" />
          <circle cx="10" cy="105" r="4.5" fill="#F4F4F2" />
          <line x1="108" y1="104" x2="90" y2="98" stroke="#D5D7DE" strokeWidth="4" strokeLinecap="round" />
          <circle cx="110" cy="105" r="4.5" fill="#F4F4F2" />
          <rect x="30" y="90" width="60" height="22" rx="11" fill="#16223F" stroke="#6F97FF" strokeWidth="2" />
          <text x="60" y="105" textAnchor="middle" fontFamily="Geist Mono, monospace" fontSize="10" fill="#B5CBFF">qc</text>
          <line x1="60" y1="10" x2="60" y2="26" stroke="#C9CCD6" strokeWidth="3" />
          <circle cx="60" cy="9" r="6.5" fill="#22C3A6" />
          <rect x="18" y="24" width="84" height="64" rx="22" fill="#F7F7F5" stroke="#E2E3E8" strokeWidth="1.5" />
          <circle cx="45" cy="53" r="5.5" fill="#141414" />
          <circle cx="46.8" cy="51.2" r="1.8" fill="#fff" />
          <circle cx="75" cy="53" r="5.5" fill="#141414" />
          <circle cx="76.8" cy="51.2" r="1.8" fill="#fff" />
          <ellipse cx="32" cy="69" rx="5.5" ry="3.2" fill="#F7B6C2" />
          <ellipse cx="88" cy="69" rx="5.5" ry="3.2" fill="#F7B6C2" />
          <path d="M52 71 Q60 75 68 71" stroke="#141414" strokeWidth="3.5" fill="none" strokeLinecap="round" />
          <circle cx="45" cy="53" r="12" fill="rgba(34,195,166,.08)" stroke="#22C3A6" strokeWidth="3" />
          <circle cx="75" cy="53" r="12" fill="rgba(34,195,166,.08)" stroke="#22C3A6" strokeWidth="3" />
          <line x1="57" y1="52" x2="63" y2="52" stroke="#22C3A6" strokeWidth="3" />
        </>
      )}
      {a === 'rani' && (
        <>
          <line x1="12" y1="96" x2="30" y2="98" stroke="#D5D7DE" strokeWidth="4" strokeLinecap="round" />
          <circle cx="10" cy="95" r="4.5" fill="#F4F4F2" />
          <line x1="108" y1="96" x2="90" y2="98" stroke="#D5D7DE" strokeWidth="4" strokeLinecap="round" />
          <circle cx="110" cy="95" r="4.5" fill="#F4F4F2" />
          <rect x="30" y="90" width="60" height="22" rx="11" fill="#16223F" stroke="#6F97FF" strokeWidth="2" />
          <text x="60" y="105" textAnchor="middle" fontFamily="Geist Mono, monospace" fontSize="10" fill="#B5CBFF">care</text>
          <line x1="60" y1="12" x2="60" y2="26" stroke="#C9CCD6" strokeWidth="3" />
          <path d="M60 17 L51.5 8.5 A5 5 0 0 1 60 2.5 A5 5 0 0 1 68.5 8.5 Z" fill="#F5B544" />
          <rect x="18" y="24" width="84" height="64" rx="22" fill="#F7F7F5" stroke="#E2E3E8" strokeWidth="1.5" />
          <path d="M39 54 Q45 47 51 54" stroke="#141414" strokeWidth="3.5" fill="none" strokeLinecap="round" />
          <path d="M69 54 Q75 47 81 54" stroke="#141414" strokeWidth="3.5" fill="none" strokeLinecap="round" />
          <ellipse cx="33" cy="65" rx="8" ry="4.6" fill="#F59FB1" />
          <ellipse cx="87" cy="65" rx="8" ry="4.6" fill="#F59FB1" />
          <path d="M49 64 Q60 80 71 64 Z" fill="#141414" />
          <path d="M54 71 Q60 76 66 71 Q60 69 54 71 Z" fill="#F59FB1" />
        </>
      )}
      {a === 'wira' && (
        <>
          <line x1="12" y1="104" x2="30" y2="98" stroke="#D5D7DE" strokeWidth="4" strokeLinecap="round" />
          <circle cx="10" cy="105" r="4.5" fill="#F4F4F2" />
          <line x1="108" y1="104" x2="90" y2="98" stroke="#D5D7DE" strokeWidth="4" strokeLinecap="round" />
          <circle cx="110" cy="105" r="4.5" fill="#F4F4F2" />
          <rect x="30" y="90" width="60" height="22" rx="11" fill="#16223F" stroke="#6F97FF" strokeWidth="2" />
          <text x="60" y="105" textAnchor="middle" fontFamily="Geist Mono, monospace" fontSize="10" fill="#B5CBFF">gudang</text>
          <rect x="18" y="24" width="84" height="64" rx="22" fill="#F7F7F5" stroke="#E2E3E8" strokeWidth="1.5" />
          <circle cx="45" cy="55" r="6.5" fill="#141414" />
          <circle cx="47.2" cy="52.8" r="2" fill="#fff" />
          <circle cx="75" cy="55" r="6.5" fill="#141414" />
          <circle cx="77.2" cy="52.8" r="2" fill="#fff" />
          <ellipse cx="34" cy="68" rx="6.5" ry="3.8" fill="#F7B6C2" />
          <ellipse cx="86" cy="68" rx="6.5" ry="3.8" fill="#F7B6C2" />
          <path d="M51 68 Q60 75 69 68" stroke="#141414" strokeWidth="3.5" fill="none" strokeLinecap="round" />
          <path d="M24 36 Q24 8 60 8 Q96 8 96 36 Z" fill="#A78BFA" />
          <rect x="12" y="32" width="96" height="9" rx="4.5" fill="#8B6FF0" />
          <rect x="55" y="9" width="10" height="24" rx="4" fill="#8B6FF0" />
        </>
      )}
      {a === 'tara' && (
        <>
          <line x1="12" y1="104" x2="30" y2="98" stroke="#D5D7DE" strokeWidth="4" strokeLinecap="round" />
          <circle cx="10" cy="105" r="4.5" fill="#F4F4F2" />
          <line x1="108" y1="104" x2="90" y2="98" stroke="#D5D7DE" strokeWidth="4" strokeLinecap="round" />
          <circle cx="110" cy="105" r="4.5" fill="#F4F4F2" />
          <rect x="30" y="90" width="60" height="22" rx="11" fill="#16223F" stroke="#6F97FF" strokeWidth="2" />
          <text x="60" y="105" textAnchor="middle" fontFamily="Geist Mono, monospace" fontSize="10" fill="#B5CBFF">buyer</text>
          <line x1="60" y1="14" x2="60" y2="26" stroke="#C9CCD6" strokeWidth="3" />
          <circle cx="60" cy="10" r="8" fill="#FF8A5B" />
          <ellipse cx="66" cy="2" rx="5.5" ry="2.6" fill="#3DD68C" transform="rotate(-25 66 2)" />
          <rect x="18" y="24" width="84" height="64" rx="22" fill="#F7F7F5" stroke="#E2E3E8" strokeWidth="1.5" />
          <circle cx="45" cy="53" r="6.5" fill="#141414" />
          <circle cx="47.2" cy="50.8" r="2" fill="#fff" />
          <path d="M69 54 Q75 48 81 54" stroke="#141414" strokeWidth="3.5" fill="none" strokeLinecap="round" />
          <ellipse cx="34" cy="66" rx="6.5" ry="3.8" fill="#F7B6C2" />
          <ellipse cx="86" cy="66" rx="6.5" ry="3.8" fill="#F7B6C2" />
          <path d="M50 66 Q60 76 70 66" stroke="#141414" strokeWidth="3.5" fill="none" strokeLinecap="round" />
        </>
      )}
    </svg>
  );
}
